import { render, staticRenderFns } from "./listDocumentos.vue?vue&type=template&id=8aa1a786&scoped=true&"
import script from "./listDocumentos.ts?vue&type=script&lang=ts&"
export * from "./listDocumentos.ts?vue&type=script&lang=ts&"
import style0 from "./listDocumentos.vue?vue&type=style&index=0&id=8aa1a786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa1a786",
  null
  
)

export default component.exports